import styles from './AppFooter.module.scss'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faXTwitter,
  faInstagram
} from '@fortawesome/free-brands-svg-icons'
import { useTranslation } from 'next-i18next'
import { faArrowUpRightFromSquare } from '@fortawesome/free-solid-svg-icons'
import { FC } from 'react'
import Link from 'next/link'
import { UiAppearance } from '~/modules/UiVariant/appearance'

interface Props {
  appearance?: UiAppearance
}

export const AppFooter: FC<Props> = ({ appearance = 'default' }) => {
  const { t } = useTranslation('footer')

  return (
    <footer
      className={ `
        ${styles.appFooter__container}
        ${appearance === 'museumHome' ? styles.museumHome : ''}
      ` }
    >
      <div className={ styles.appFooter__contentContainer }>
        <div className={ styles.appFooter__platform }>
          <Link
            className={ styles.appFooter__platform__item }
            href="https://factory.belegends.com/"
            target="_blank"
          >
            Legend Factory
          </Link>

          <Link
            className={ styles.appFooter__platform__item }
            href="https://verify.belegends.com/"
            target="_blank"
          >
            Legend Verify
          </Link>
        </div>

        <div className={ styles.appFooter__socialNetworksList }>
          <a
            className={ styles.appFooter__socialNetworkLink }
            href="https://www.instagram.com/belegends.ok/"
            target="_blank"
            rel="noreferrer"
            title="Instagram"
          >
            <FontAwesomeIcon
              className="fa-fw"
              icon={ faInstagram }
            />
          </a>

          <a
            className={ styles.appFooter__socialNetworkLink }
            href="https://x.com/belegends_ok"
            target="_blank"
            rel="noreferrer"
            title="Twitter"
          >
            <FontAwesomeIcon
              className="fa-fw"
              icon={ faXTwitter }
            />
          </a>
        </div>

        <a
          className={ styles.appFooter__copyright }
          href="https://belegends.com"
          target="_blank"
          rel="noreferrer"
        >
          { t('copyright') }
        </a>

        <div className={ styles.appFooter__contact }>
          <Link
            className={ styles.appFooter__contact__item }
            href='/faq'
          >
            FAQ
          </Link>

          <a
            className={ styles.appFooter__contact__item }
            href="mailto:support@belegends.com"
            target="_blank"
            rel="noreferrer"
          >
            { t('contact_link') }

            <FontAwesomeIcon
              className={ styles.appFooter__contactIconLink }
              icon={ faArrowUpRightFromSquare }
            />
          </a>
        </div>
      </div>
    </footer>
  )
}
